import {HttpErrorResponse, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from "@angular/common/http";
import {catchError} from "rxjs/operators";
import {environment} from "../../environments/environment";
import {NO_FAIL} from "../utilities/http";
import {
  SnackBarTranslateComponent
} from "../shared/snack-bar-translate/snack-bar-translate/snack-bar-translate.component";
import {throwError} from "rxjs";
import {inject} from "@angular/core";
import {Router} from "@angular/router";
import {AuthService} from "./auth.service";
import {MatSnackBar} from "@angular/material/snack-bar";

export const errorInterceptor: HttpInterceptorFn = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn
) => {

  const router = inject(Router);
  const authService = inject(AuthService);
  const snackBar = inject(MatSnackBar);

  return next(req).pipe(catchError(error => {

    if(environment.type === 'dev') {
      console.log(error);
      snackBar.open(error.status === 0 ? "Bad or No response from Server" : error?.error?.message || error?.message,'Ok');
    }

    const noFail = req.context.get(NO_FAIL);

    if(error instanceof HttpErrorResponse) {
      if(error.status === 401) {
        let params;

        if(authService.lastRoute || (router.url && router.url !== '/' && !router.url.includes('auth/login'))) {
          params = {queryParams: {redirectTo: authService.lastRoute || router.url}}
          authService.lastRoute = null;
        }

        //this.router.navigate(['auth', 'login'], {replaceUrl: true, ...params});
        router.navigate(['auth', 'secret-login'], {replaceUrl: true, ...params});
        //this.router.navigate(['new-app']);
      } else if (!noFail && (error.status >= 500)) {
        router.navigate(['500'], { skipLocationChange: true ,state: {error: error.status ? error.status : '500', message: error.error.message || error.message}});
      } else if (!noFail && error.status == 0) {
        snackBar.openFromComponent(SnackBarTranslateComponent, {
          data: {key: 'main.no.internet'}, duration: 10000
        })
      } else if(error.error?.exception?.code){
        const code = error.error.exception.code;
        if(code != 'GL_6' && code != 'GL_7')
          snackBar.openFromComponent(SnackBarTranslateComponent, {
            data: {key: `exceptions.backend.${error.error.exception.code}`}, duration: 10000
          })
      }
    }

    return throwError(() => error);
  }));

}
